import type { SharedApiV2 } from "@capstone/mock-api";
import { DashboardTicketOrderVendor } from "src/app/partner/help-assist/models/ticket-appointment-draft/dashboard-ticket-order-vendor.model";

export class DashboardTicketAppointmentOrder {
  private constructor(args: ClassProperties<DashboardTicketAppointmentOrder>) {
    this.id = args.id;
    this.vendor = args.vendor;
  }

  public readonly id: number;
  public readonly vendor: DashboardTicketOrderVendor | null;

  public static deserialize(
    apiModel: SharedApiV2.TicketOrderDto,
  ): DashboardTicketAppointmentOrder {
    return new DashboardTicketAppointmentOrder({
      id: apiModel.id,
      vendor:
        apiModel.vendor &&
        DashboardTicketOrderVendor.deserialize(apiModel.vendor),
    });
  }
}
